/**
 * Helper to robustly extract file extension from source location, name, title, or presigned URL.
 * Cleans query parameters and hashes before extracting extension.
 */
import type { Source } from '../../lib/models/Chat';

export type ExtendedSource = Partial<Source> & { title?: string; excerpt?: string };

export const getFileExtension = (source?: ExtendedSource | null, url?: string): string => {
    const candidates = [
        source?.location,
        source?.name,
        source?.title,
        source?.presigned_url,
        url,
    ];

    for (const candidate of candidates) {
        if (!candidate || typeof candidate !== 'string') continue;

        // Strip query string parameters and fragment hashes
        const cleanPath = candidate.split('?')[0].split('#')[0];
        const filename = cleanPath.split('/').pop() || '';

        if (filename.includes('.')) {
            const ext = filename.split('.').pop()?.toLowerCase();
            if (ext) return ext;
        }
    }

    return '';
};
